import React, { useState, useEffect, useRef } from "react";
import "./FAQTable.css";
// react-bootstrap components
import moment from "moment";
import Papa from "papaparse";
import { Badge, Button, Card, Col, Dropdown, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getProcessTime, getStatusLabel } from "utils/resources";
import { getExternalMessage, updateMessage } from "../../apis/MessageApi";
import {
  createFaq,
  deleteResource,
  listAllExternalFaqsInSelectedTime,
  listAllInternalFaqsInSelectedTime,
  listFaqs,
  requestDeletingResource,
  requestProcessingResource,
  requestReprocessingResource,
  updateResource,
  listAllFaqsWithKeyword,
  getExternalFaqById,
} from "../../apis/ResourceApi";
import BatchModalDialog from "../../components/BatchModalDialog";
import FanLoadingIcon from "../../components/FanLoadingIcon";
import useCsvDownloader from "../../components/Hooks/useCsvDownloader";
import PaginationComponent from "../../components/PaginationComponent";
import { APP_TYPE, APP_TYPES } from "../../constants/app";
import { RESOURCE_STATUS } from "../../constants/status";
import { NUM_ITEMS_PER_PAGE } from "../../constants/table";
import { useDialog } from "../../contexts/DialogContext.tsx";
import { BUTTON_LABELS, MESSAGES } from "../../lang/ja";
import UpdateAnswerDialog from "../../pages/qa/UpdateAnswerDialog";
import RejectResourceDialog from "../../pages/resource/RejectResourceDialog";
import FileRegisterDialog from "../../views/Dialog/FileRegisterDialog";
import FileEditDialog from "../../views/Dialog/FileEditDialog";
import CSVDownloadDialog from "./CSVDownloadDialog";
import FAQRegisterDialog from "./FAQRegisterDialog";

function FAQTable() {
  const [faqs, setFaqs] = useState([]);
  const [selectedFaq, setSelectedFaq] = useState(null);
  console.log("selectedFaq", selectedFaq);
  const [viewedFaq, setViewedFaq] = useState(null);
  const [selectedFaqForBatch, setSelectedFaqForBatch] = useState(null);
  const [rejectedFaq, setRejectedFaq] = useState(null);
  const [csvRegisterDialogOpen, setCsvRegisterDialogOpen] = useState(false);
  const [csvDownloadDialogOpen, setCsvDownloadDialogOpen] = useState(false);
  const [csvEditDialogOpen, setCsvEditDialogOpen] = useState(false);
  const [csvDeleteDialogOpen, setCsvDeleteDialogOpen] = useState(false);
  const { userInfo } = useSelector((state) => state.users);
  const governmentId = userInfo?.governmentId;
  const [curPage, setCurPage] = useState(0);
  const numPages = Math.ceil(faqs.length / NUM_ITEMS_PER_PAGE);
  const nextTokenRef = useRef(null);
  const [sourceMsg, setSourceMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const { success, error } = useDialog();
  const { downloadCsv } = useCsvDownloader();
  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSetScheduled = (faq) => {
    setSelectedFaqForBatch(faq);
  };

  useEffect(() => {
    const downloadFaqs = async () => {
      const res = await listFaqs(governmentId, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, null, "");
      if (res.success) {
        setFaqs(res.data);
        nextTokenRef.current = res.nextToken;
      }
    };
    if (governmentId) downloadFaqs();
  }, [governmentId]);


  const onRegisterFaq = async (question, answer, url, tag) => {
    if (loading) return;
    setLoading(true);
    let res;
    if (!selectedFaq.createdAt) {
      res = await createFaq(governmentId, question, answer, url, null, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, tag);
      console.log("createFaq", res);
    } else {
      const newProps = { name: question, answer, url, rejectReason: "", tag };
      if (selectedFaq.status !== RESOURCE_STATUS.PENDING) {
        newProps.status = RESOURCE_STATUS.PROCESS_REQUESTING;
      }
      res = await updateResource(selectedFaq, newProps);
    }
    if (res.success) {
      if (!selectedFaq.createdAt) {
        setFaqs([res.data, ...faqs]);
      } else {
        faqs.splice(
          faqs.findIndex((faq) => faq.createdAt === selectedFaq.createdAt),
          1,
          res.data
        );
        setFaqs(Object.assign([], faqs));
      }
      setSelectedFaq(null);
    }
    setLoading(false);
  };

  const onPageChange = async (page) => {
    setCurPage(page);
    if (page + 6 > numPages) {
      const nextToken = nextTokenRef.current;
      if (nextToken) {
        const res = await listFaqs(governmentId, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, nextToken, searchKeyword);
        if (res.success) {
          if (nextToken) {
            faqs.push(...res.data);
            setFaqs(Object.assign([], faqs));
          } else {
            setFaqs(res.data);
          }
          nextTokenRef.current = res.nextToken;
        }
      }
    }
  };
  const onClickQa = async (faq) => {
    if (!faq.srcMsgKey) return;
    setViewedFaq(faq);
    const srcMsgKey = JSON.parse(faq.srcMsgKey);
    const res = await getExternalMessage(srcMsgKey.conversationId, srcMsgKey.createdAt);
    console.log("res", res);
    if (res.success) {
      setSourceMsg(res.data);
    }
  };
  const onUpdateFaq = async (newAnswer, newUrl, newTag) => {
    // update tag of message
    if (newTag !== sourceMsg.tag) {
      const msgRes = await updateMessage(sourceMsg.conversationId, sourceMsg.createdAt, { tag: newTag });
      if (msgRes.success) {
        setSourceMsg(msgRes.data);
      }
    }
    // update faq
    const newProps = { name: sourceMsg.name, answer: newAnswer, url: newUrl };
    if (viewedFaq.status !== RESOURCE_STATUS.PENDING) {
      newProps.status = RESOURCE_STATUS.PROCESS_REQUESTING;
    }
    const res = await updateResource(viewedFaq, newProps);
    if (res.success) {
      const index = faqs.indexOf(viewedFaq);
      faqs.splice(index, 1, res.data);
      setFaqs(Object.assign([], faqs));
    }
    setSourceMsg(null);
    setViewedFaq(null);
  };
  const onRequestDelete = async (faq) => {
    if (loading) return;
    setLoading(true);
    const res = await requestDeletingResource(faq);
    if (res.success) {
      const pos = faqs.indexOf(faq);
      if (pos >= 0) {
        faqs.splice(pos, 1, res.data);
        setFaqs(Object.assign([], faqs));
      }
    }
    setLoading(false);
  };
  const onRequestProcess = async (faq) => {
    if (loading) return;
    setLoading(true);
    const res = await requestProcessingResource(faq);
    if (res.success) {
      const pos = faqs.indexOf(faq);
      if (pos >= 0) {
        faqs.splice(pos, 1, res.data);
        setFaqs(Object.assign([], faqs));
      }
    }
    setLoading(false);
  };
  const onRequestReprocess = async (faq) => {
    if (loading) return;
    setLoading(true);
    const res = await requestReprocessingResource(faq);
    if (res.success) {
      const pos = faqs.indexOf(faq);
      if (pos >= 0) {
        faqs.splice(pos, 1, res.data);
        setFaqs(Object.assign([], faqs));
      }
    }
    setLoading(false);
  };
  const onDeleteFaq = async (faq) => {
    if (loading) return;
    setLoading(true);
    const res = await deleteResource(faq);
    if (res.success) {
      const pos = faqs.indexOf(faq);
      faqs.splice(pos, 1);
      setFaqs(Object.assign([], faqs));
      success(MESSAGES.DELETED_FAQ_SUCCESSFULLY);
    } else {
      error(MESSAGES.SOMETHING_WRONG);
    }
    setLoading(false);
  };
  const onRegisterCsv = async (files) => {
    setCsvRegisterDialogOpen(false);
    if (loading) return;
    let newFaqs = faqs;
    for (const file of files) {
      Papa.parse(file, {
        worker: true,
        async complete({ data }) {
          setLoading(true);
          let questionPos, answerPos, urlPos;
          for (const item of data) {
            if (item === data[0]) {
              questionPos = item.indexOf("question");
              answerPos = item.indexOf("answer");
              urlPos = item.indexOf("url");
            } else if (item[0] && item[1]) {
              const res = await createFaq(
                governmentId,
                item[questionPos],
                item[answerPos],
                item[urlPos],
                null,
                APP_TYPE === APP_TYPES.OUTSIDE_ADMIN
              );
              if (res.success) {
                newFaqs = [res.data, ...newFaqs];
                setFaqs(newFaqs);
              }
            }
          }
          setLoading(false);
        },
      });
    }
  };
  const onDownloadCsv = async (selectedTime) => {
    setCsvDownloadDialogOpen(false);
    setLoading(true);
    const res = await (APP_TYPE === APP_TYPES.INSIDE_ADMIN
      ? listAllInternalFaqsInSelectedTime(governmentId, selectedTime)
      : listAllExternalFaqsInSelectedTime(governmentId, selectedTime));
    if (res.success) {
      let data = res.data.map((faq) => {
        return [faq.id, faq.name, faq.answer, faq.url, faq.createdAt];
      });
      data = [["id", "question", "answer", "url", "createdAt"], ...data];
      await downloadCsv(data, "faq_" + selectedTime + ".csv");
    } else {
      error(MESSAGES.SOMETHING_WRONG);
    }
    setLoading(false);
  };

  // 一括テンプレートダウンロード
  const onDownloadTemplate = async (templateType) => {
    setCsvDownloadDialogOpen(false);
    setLoading(true);
    const template = {
      "register": {
        "name": "faq_template.csv",
        "header": ["question", "answer", "url"],
        "data": ["質問", "答えです", "https://www.example.com/"]
      },
      "edit": {
        "name": "faq_edit_template.csv",
        "header": ["id", "question", "answer", "url"],
        "data": ["3ce90b20-0f26-424b-8c3f-299364b1b66a", "質問", "答えです", "https://www.example.com/"]
      },
      "delete": {
        "name": "faq_delete_template.csv",
        "header": ["id"],
        "data": ["3ce90b20-0f26-424b-8c3f-299364b1b66a"]
      }
    }

    // デフォルトは登録テンプレート
    if(!templateType){templateType = "register";}
    const templateName = template[templateType].name;
    const data = [
      template[templateType].header,
      template[templateType].data,
    ];
    await downloadCsv(data, templateName);
    setLoading(false);
  };

  // 一括編集
  const onEditCsv = async (files) => {
    setCsvEditDialogOpen(false);
    if (loading) return;
    for (const file of files) {
      Papa.parse(file, {
        worker: true,
        async complete({ data }) {
          setLoading(true);
          let idPos, questionPos, answerPos, urlPos;
          for (const item of data) {
            if (item === data[0]) {
              idPos = item.indexOf("id");
              questionPos = item.indexOf("question");
              answerPos = item.indexOf("answer");
              urlPos = item.indexOf("url");
            } else if (item[0] && item[1]) {
              let faq = faqs.find((faq) => faq.id === item[idPos]);
              if (!faq) {
                // 存在しない場合は取得
                const res = await getExternalFaqById(governmentId, item[idPos]);

                if (res.success) {
                  faq = res.data;
                  // console.log("faq found from fetching", faq);
                }

                // 存在しない場合はスキップ
                if (!faq) {
                  console.log("faq not found", item[idPos]);
                  continue;
                }
              }

              const isEditable = faq && (faq.status === RESOURCE_STATUS.PENDING ||
                faq.status === RESOURCE_STATUS.PROCESS_REJECTED ||
                faq.status === RESOURCE_STATUS.FINISHED ||
                faq.status === RESOURCE_STATUS.FAILED);
              if (isEditable) {
                const newProps = { name: item[questionPos], answer: item[answerPos], url: item[urlPos] };
                if (faq.status !== RESOURCE_STATUS.PENDING) {
                  newProps.status = RESOURCE_STATUS.PENDING;
                }
                const res = await updateResource(faq, newProps);
                if (res.success) {
                  if(faqs.indexOf(faq) >= 0) {
                    faqs.splice(faqs.indexOf(faq), 1, res.data);
                    setFaqs(Object.assign([], faqs));
                  }
                }
              } else {
                console.log("faq is not editable", faq);
              }
            }
          }
          setLoading(false);
        }
      });
    }
  }

  // 一括削除
  const onDeleteCsv = async (files) => {
    setCsvDeleteDialogOpen(false);
    if (loading) return;
    for (const file of files) {
      Papa.parse(file, {
        worker: true,
        async complete({ data }) {
          setLoading(true);
          let idPos;
          for (const item of data) {
            if (item === data[0]) {
              idPos = item.indexOf("id");
            } else {
              let faq = faqs.find((faq) => faq.id === item[idPos]);
              if (!faq) {
                // 存在しない場合は取得
                const res = await getExternalFaqById(governmentId, item[idPos]);

                if (res.success) {
                  faq = res.data;
                  // console.log("faq found from fetching", faq);
                }

                // 存在しない場合はスキップ
                if (!faq) {
                  console.log("faq not found", item[idPos]);
                  continue;
                }
              }

              // ロード済みの場合は削除リクエスト
              if (faq.status === RESOURCE_STATUS.FINISHED) {
                const res = await requestDeletingResource(faq);
                if (res.success) {
                  const pos = faqs.indexOf(faq);
                  faqs.splice(pos, 1, res.data);
                  setFaqs(Object.assign([], faqs));
                }
              }
              // 編集中の場合は削除
              else if (faq.status === RESOURCE_STATUS.PENDING) {
                const res = await deleteResource(faq);
                if (res.success) {
                  if(faqs.indexOf(faq) >= 0) {
                    const pos = faqs.indexOf(faq);
                    faqs.splice(pos, 1);
                    setFaqs(Object.assign([], faqs));
                  }
                }
              }
              else {
                console.log("faq is not deletable", faq);
              }
            }
          }
          setLoading(false);
        }
      });
    }
  };

  const onUpdateResourceExecution = async (executionType, executionDetail) => {
    if (loading) return;
    setLoading(true);
    const faq = selectedFaqForBatch;
    const res = await updateResource(faq, { execution: executionType, executionDetail });

    if (res.success) {
      success(MESSAGES.EXECUTION_UPDATED_SUCCESSFULLY);
      faqs.splice(faqs.indexOf(selectedFaqForBatch), 1, res.data);
      setFaqs(Object.assign([], faqs));
    } else {
      error(MESSAGES.SOMETHING_WRONG);
    }
    setLoading(false);
    setSelectedFaqForBatch(null);
  };

  const handleSearch = async () => {
    setCurPage(0);
    nextTokenRef.current = null;
    setLoading(true);

    // キーワードがある場合は全件検索、ない場合は通常のページネーション検索
    const res = searchKeyword && searchKeyword.trim() !== ""
      ? await listAllFaqsWithKeyword(governmentId, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, searchKeyword)
      : await listFaqs(governmentId, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, null, "");

    if (res.success) {
      setFaqs(res.data);
      // 全件検索の場合はnextTokenをnullに設定
      nextTokenRef.current = searchKeyword && searchKeyword.trim() !== "" ? null : res.nextToken;
    }
    setLoading(false);
  };

  const handleResetSearch = async () => {
    setSearchKeyword("");
    setCurPage(0);
    nextTokenRef.current = null;
    const res = await listFaqs(governmentId, APP_TYPE === APP_TYPES.OUTSIDE_ADMIN, null, "");
    if (res.success) {
      setFaqs(res.data);
      nextTokenRef.current = res.nextToken;
    }
  };

  /***** Main Render *****/
  return (
    <>
      <Col md="12">
        <Card className="strpied-tabled-with-hover">
          <Card.Header>
            <Card.Title as="h4">データ管理 &gt; FAQ</Card.Title>
            <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
              <div className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="質問文を入力"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  style={{ width: "300px" }}
                />
                <Button variant="primary" onClick={handleSearch}>
                  検索
                </Button>
                <Button
                  variant="link"
                  onClick={handleResetSearch}
                  className="text-primary p-0 ms-3"
                  style={{ textDecoration: "none" }}
                >
                  リセット
                </Button>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-between align-items-end">
              <PaginationComponent currentPage={curPage} totalItems={faqs.length} onPageChange={onPageChange} />
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    style={{
                      backgroundColor: "#0062cc",
                    }}
                  >
                    登録 - DL
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      className="faq_table_dropdown_item"
                      onClick={() => {
                        setSelectedFaq({});
                      }}
                    >
                      {BUTTON_LABELS.BUTTON_REGISTER_NEW}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="faq_table_dropdown_item"
                      onClick={() => {
                        setCsvRegisterDialogOpen(true);
                      }}
                    >
                      {BUTTON_LABELS.BUTTON_REGISTER_CSV}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="faq_table_dropdown_item"
                      onClick={() => {
                        setCsvEditDialogOpen(true);
                      }}
                    >
                      {BUTTON_LABELS.BUTTON_EDIT_CSV}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="faq_table_dropdown_item"
                      onClick={() => {
                        setCsvDeleteDialogOpen(true);
                      }}
                    >
                      {BUTTON_LABELS.BUTTON_DELETE_CSV}
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="faq_table_dropdown_item"
                      onClick={() => {
                        setCsvDownloadDialogOpen(true);
                      }}
                    >
                      {BUTTON_LABELS.BUTTON_DOWNLOAD}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="table-responsive p-0 overflow-auto">
            <Table className="table-hover table-striped w-full">
              <thead>
                <tr>
                  <th>質問</th>
                  <th>更新日時</th>
                  <th>部署タグ</th>
                  <th>反映予定日時</th>
                  <th>ステータス</th>
                  <th>アクション</th>
                </tr>
              </thead>
              <tbody>
                {faqs.map((faq, i) => {
                  if (i < curPage * NUM_ITEMS_PER_PAGE || i >= (curPage + 1) * NUM_ITEMS_PER_PAGE) return null;
                  const status = faq.status;
                  // eslint-disable-next-line react/jsx-key
                  return (
                    <tr key={i}>
                      <td>{faq.name}</td>
                      <td>{moment(faq.updatedAt).format("yyyy/MM/DD HH:mm")}</td>
                      <td>
                        {faq.tag !== "undefined" && faq.tag ? (
                          <Badge
                            style={{
                              backgroundColor: "#007bff",
                              color: "#ffffff",
                              padding: "0.4em 0.8em",
                              fontSize: "0.8rem",
                              borderRadius: "16px",
                              fontWeight: "normal",
                              display: "inline-block",
                              cursor: "pointer",
                            }}
                          >
                            {faq.tag}
                          </Badge>
                        ) : (
                          <span className="text-muted">未分類</span>
                        )}
                      </td>
                      <td>{getProcessTime(faq)}</td>
                      <td>
                        {getStatusLabel(faq)}
                        {faq.rejectReason && (
                          <button
                            className="button_reject_reason"
                            onClick={() => {
                              setRejectedFaq(faq);
                            }}
                          >
                            !
                          </button>
                        )}
                      </td>
                      <td>
                        {/***** QA *****/}
                        {faq.srcMsgKey && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              onClickQa(faq);
                            }}
                          >
                            QA
                          </Button>
                        )}
                        {/***** EDIT *****/}
                        {(status === RESOURCE_STATUS.PENDING ||
                          status === RESOURCE_STATUS.PROCESS_REJECTED ||
                          status === RESOURCE_STATUS.FINISHED ||
                          status === RESOURCE_STATUS.FAILED) && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              setSelectedFaq(faq);
                            }}
                          >
                            編集
                          </Button>
                        )}
                        {/***** REQUEST PROCESS *****/}
                        {(status === RESOURCE_STATUS.PENDING || status === RESOURCE_STATUS.PROCESS_REJECTED) && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              onRequestProcess(faq);
                            }}
                          >
                            {BUTTON_LABELS.BUTTON_REQUEST_PROCESS}
                          </Button>
                        )}
                        {/***** REQUEST REPROCESS *****/}
                        {status === RESOURCE_STATUS.FAILED && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              onRequestReprocess(faq);
                            }}
                          >
                            {BUTTON_LABELS.BUTTON_REQUEST_REPROCESS}
                          </Button>
                        )}
                        {/***** REQUEST DELETE *****/}
                        {status === RESOURCE_STATUS.FINISHED && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              onRequestDelete(faq);
                            }}
                          >
                            {BUTTON_LABELS.BUTTON_REQUEST_DELETE}
                          </Button>
                        )}
                        {/***** DELETE *****/}
                        {status === RESOURCE_STATUS.PENDING && (
                          <Button
                            className="btn-outline mr-1"
                            variant="default"
                            onClick={() => {
                              onDeleteFaq(faq);
                            }}
                          >
                            {BUTTON_LABELS.BUTTON_DELETE}
                          </Button>
                        )}
                        {/***** SET SCHEDULED *****/}
                        <Button
                          className="btn-outline mr-1"
                          variant="default"
                          onClick={() => {
                            handleSetScheduled(faq);
                          }}
                        >
                          {BUTTON_LABELS.BUTTON_SET_SCHEDULED}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      <FAQRegisterDialog
        isOpen={!!selectedFaq}
        faq={selectedFaq}
        tag={selectedFaq?.tag}
        onClose={() => {
          setSelectedFaq(null);
        }}
        onRegister={onRegisterFaq}
      />
      <BatchModalDialog
        isOpen={!!selectedFaqForBatch}
        isCreateDialog={selectedFaqForBatch?.status === RESOURCE_STATUS.FINISHED}
        onClose={() => {
          setSelectedFaqForBatch(null);
        }}
        enableRecurring={false}
        onSubmit={onUpdateResourceExecution}
        initExecutionType={selectedFaqForBatch?.execution}
        initExecutionDetail={selectedFaqForBatch?.executionDetail}
        editable={
          selectedFaqForBatch?.status !== RESOURCE_STATUS.PROCESSING &&
          selectedFaqForBatch?.status !== RESOURCE_STATUS.WAITING
        }
      />
      <FileRegisterDialog
        isOpen={csvRegisterDialogOpen}
        onClose={() => {
          setCsvRegisterDialogOpen(false);
        }}
        accept={[".csv"]}
        onRegister={onRegisterCsv}
        hasTemplate={true}
        onDownloadTemplate={() => onDownloadTemplate("register")}
      />
      <FileEditDialog
        isOpen={csvEditDialogOpen}
        onClose={() => {
          setCsvEditDialogOpen(false);
        }}
        accept={[".csv"]}
        onButtonPressed={onEditCsv}
        hasTemplate={true}
        onDownloadTemplate={() => onDownloadTemplate("edit")}
        buttonLabel={"編集"}
      />
      <FileEditDialog
        isOpen={csvDeleteDialogOpen}
        onClose={() => {
          setCsvDeleteDialogOpen(false);
        }}
        accept={[".csv"]}
        onButtonPressed={onDeleteCsv}
        hasTemplate={true}
        onDownloadTemplate={() => onDownloadTemplate("delete")}
        buttonLabel={"削除"}
      />
      <CSVDownloadDialog
        isOpen={csvDownloadDialogOpen}
        onClose={() => setCsvDownloadDialogOpen(false)}
        onDownload={onDownloadCsv}
      />
      <UpdateAnswerDialog
        isOpen={!!sourceMsg}
        question={sourceMsg?.question}
        answer={viewedFaq?.answer}
        aiAnswer={sourceMsg?.answer + "\n" + sourceMsg?.url}
        tag={sourceMsg?.tag}
        url={viewedFaq?.url}
        onClose={() => {
          setSourceMsg(null);
        }}
        onUpdate={onUpdateFaq}
      />
      <RejectResourceDialog
        isOpen={!!rejectedFaq}
        onClose={() => {
          setRejectedFaq(null);
        }}
        reason={rejectedFaq?.rejectReason}
      />
      {loading && <FanLoadingIcon size={80} />}
    </>
  );
}

export default FAQTable;
